import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_7886c98d from 'nuxt_plugin_plugin_7886c98d' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_2a2ead81 from 'nuxt_plugin_plugin_2a2ead81' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_interpolation_71408b96 from 'nuxt_plugin_interpolation_71408b96' // Source: ./interpolation.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_7687cc6a from 'nuxt_plugin_cookieuniversalnuxt_7687cc6a' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_markdownit_3307383b from 'nuxt_plugin_markdownit_3307383b' // Source: ./markdownit.js (mode: 'all')
import nuxt_plugin_image_ac5fc5c4 from 'nuxt_plugin_image_ac5fc5c4' // Source: ./image.js (mode: 'all')
import nuxt_plugin_axios_826dbfba from 'nuxt_plugin_axios_826dbfba' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_pluginutils_47598f10 from 'nuxt_plugin_pluginutils_47598f10' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_6b30f07a from 'nuxt_plugin_pluginrouting_6b30f07a' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_1e75328c from 'nuxt_plugin_pluginmain_1e75328c' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_pluginserver_3dd1e98a from 'nuxt_plugin_pluginserver_3dd1e98a' // Source: ./plugin.server.js (mode: 'server')
import nuxt_plugin_datefns_177dfa6e from 'nuxt_plugin_datefns_177dfa6e' // Source: ./date-fns.js (mode: 'all')
import nuxt_plugin_veevalidate_21716614 from 'nuxt_plugin_veevalidate_21716614' // Source: ../plugins/vee-validate.js (mode: 'all')
import nuxt_plugin_vueawesomecountdownclient_cae36bac from 'nuxt_plugin_vueawesomecountdownclient_cae36bac' // Source: ../plugins/vue-awesome-countdown.client.js (mode: 'client')
import nuxt_plugin_axios_397e53b5 from 'nuxt_plugin_axios_397e53b5' // Source: ../plugins/axios.js (mode: 'all')
import nuxt_plugin_eavformatter_01020a74 from 'nuxt_plugin_eavformatter_01020a74' // Source: ../plugins/eav-formatter.js (mode: 'all')
import nuxt_plugin_youtubeclient_cec06466 from 'nuxt_plugin_youtubeclient_cec06466' // Source: ../plugins/youtube.client.js (mode: 'client')
import nuxt_plugin_posthogclient_ffd0bbec from 'nuxt_plugin_posthogclient_ffd0bbec' // Source: ../plugins/posthog.client.js (mode: 'client')
import nuxt_plugin_gtmclient_3f4ec18a from 'nuxt_plugin_gtmclient_3f4ec18a' // Source: ../plugins/gtm.client.js (mode: 'client')
import nuxt_plugin_chatbaseclient_a8951c8a from 'nuxt_plugin_chatbaseclient_a8951c8a' // Source: ../plugins/chatbase.client.js (mode: 'client')
import nuxt_plugin_tapfiliateclient_45bfb721 from 'nuxt_plugin_tapfiliateclient_45bfb721' // Source: ../plugins/tapfiliate.client.js (mode: 'client')
import nuxt_plugin_vuetelinputvuetifyclient_f6167c88 from 'nuxt_plugin_vuetelinputvuetifyclient_f6167c88' // Source: ../plugins/vue-tel-input-vuetify.client.js (mode: 'client')
import nuxt_plugin_viewportclient_3e0d03f8 from 'nuxt_plugin_viewportclient_3e0d03f8' // Source: ../plugins/viewport.client.js (mode: 'client')
import nuxt_plugin_auth_543478ad from 'nuxt_plugin_auth_543478ad' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_authrecover_20e5a122 from 'nuxt_plugin_authrecover_20e5a122' // Source: ../plugins/auth-recover.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"de"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"}],"link":[{"rel":"icon","type":"image\u002Fsvg+xml","href":"\u002Ffavicon.svg"},{"rel":"alternate icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_7886c98d === 'function') {
    await nuxt_plugin_plugin_7886c98d(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_2a2ead81 === 'function') {
    await nuxt_plugin_plugin_2a2ead81(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_interpolation_71408b96 === 'function') {
    await nuxt_plugin_interpolation_71408b96(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_7687cc6a === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_7687cc6a(app.context, inject)
  }

  if (typeof nuxt_plugin_markdownit_3307383b === 'function') {
    await nuxt_plugin_markdownit_3307383b(app.context, inject)
  }

  if (typeof nuxt_plugin_image_ac5fc5c4 === 'function') {
    await nuxt_plugin_image_ac5fc5c4(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_826dbfba === 'function') {
    await nuxt_plugin_axios_826dbfba(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_47598f10 === 'function') {
    await nuxt_plugin_pluginutils_47598f10(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_6b30f07a === 'function') {
    await nuxt_plugin_pluginrouting_6b30f07a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_1e75328c === 'function') {
    await nuxt_plugin_pluginmain_1e75328c(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_3dd1e98a === 'function') {
    await nuxt_plugin_pluginserver_3dd1e98a(app.context, inject)
  }

  if (typeof nuxt_plugin_datefns_177dfa6e === 'function') {
    await nuxt_plugin_datefns_177dfa6e(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_21716614 === 'function') {
    await nuxt_plugin_veevalidate_21716614(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueawesomecountdownclient_cae36bac === 'function') {
    await nuxt_plugin_vueawesomecountdownclient_cae36bac(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_397e53b5 === 'function') {
    await nuxt_plugin_axios_397e53b5(app.context, inject)
  }

  if (typeof nuxt_plugin_eavformatter_01020a74 === 'function') {
    await nuxt_plugin_eavformatter_01020a74(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_youtubeclient_cec06466 === 'function') {
    await nuxt_plugin_youtubeclient_cec06466(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_posthogclient_ffd0bbec === 'function') {
    await nuxt_plugin_posthogclient_ffd0bbec(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtmclient_3f4ec18a === 'function') {
    await nuxt_plugin_gtmclient_3f4ec18a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_chatbaseclient_a8951c8a === 'function') {
    await nuxt_plugin_chatbaseclient_a8951c8a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_tapfiliateclient_45bfb721 === 'function') {
    await nuxt_plugin_tapfiliateclient_45bfb721(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetelinputvuetifyclient_f6167c88 === 'function') {
    await nuxt_plugin_vuetelinputvuetifyclient_f6167c88(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_viewportclient_3e0d03f8 === 'function') {
    await nuxt_plugin_viewportclient_3e0d03f8(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_543478ad === 'function') {
    await nuxt_plugin_auth_543478ad(app.context, inject)
  }

  if (typeof nuxt_plugin_authrecover_20e5a122 === 'function') {
    await nuxt_plugin_authrecover_20e5a122(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
